import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as r, normalizeClass as d, createElementVNode as s } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const o = {
  name: "DtIconAccessibility",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ s("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-3.354.146a.5.5 0 0 1 .593-.085l2.75 1.5a.5.5 0 0 1 .168.73L6.25 5.562a2.998 2.998 0 0 1 .435.381l2.736-.438a.5.5 0 0 1 .574.565l-.5 3.5a.5.5 0 0 1-.99-.142L8.909 6.6l-1.633.261a3 3 0 0 1 .218.946c.024.383-.024.756-.139 1.108a.5.5 0 1 1-.95-.312 2 2 0 0 0-2.033-2.6h-.001a1.94 1.94 0 0 0-.717.183.5.5 0 0 1-.428-.904 3 3 0 0 1 2.112-.164l.678-.95-1.927-1.05-1.235 1.235a.5.5 0 1 1-.708-.708l1.5-1.5Zm-1.37 4.619a.5.5 0 0 1 .32.63 2 2 0 0 0 2.033 2.6 1.92 1.92 0 0 0 .717-.182.5.5 0 0 1 .428.904 3 3 0 0 1-4.268-2.525 2.953 2.953 0 0 1 .139-1.108.5.5 0 0 1 .63-.32Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, f, i, h, p, a) {
  return r(), l("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--accessibility"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Accessibility",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, m, 10, c);
}
const y = /* @__PURE__ */ n(o, [["render", u]]);
export {
  y as default
};
//# sourceMappingURL=accessibility.js.map
